export default {
	"name": "QuickLizard",
	"stage": "produktion",
	"mandanten": ["2", "4", "55"],
	"pagetypes": ["produkt", "dankeseite"],
	"requiresConsent": false,
	"serviceSettings": {
		"apiUrl": "/proxy/lizard"
	}
}
